export default class DeviceComplianceSettingsProvider {

    static getOnboardingV3Settings() {
        return {
            mode: 'onboarding-v3',
            successUrl: {
                appName: 'onboarding',
                url: '/signup/v2/all-set',
            },
            failUrl: {
                appName: 'signin',
                url: '/'
            }
        };
    }

    static getMfaSettings() {
        return {
            mode: 'mfa',
            successUrl: {
                appName: 'signin',
                url: '/session-status',
            },
            failUrl: {
                appName: 'signin',
                url: '/'
            }
        };
    }

    static getNativeAppInstallationSettings() {
        return {
            mode: 'install',
            successUrl: {
                appName: 'signin',
                url: '/session-status',
            },
            failUrl: {
                appName: 'signin',
                url: '/'
            }
        };
    }
}


// WEBPACK FOOTER //
// ./src/scripts/services/deviceComplianceSettingsProvider.js